<template>
  <cham-block animation-class="slideInDown">
    <cham-header main-title="Portfolio ;" subtitle="Applications • Open Source • Collaborations"/>
    <div v-if="busy">
      <p class="subtitle is-5 is-center">Loading..</p>
    </div>
    <div class="content" v-else>

      <div class="columns section is-centered" v-cloak v-match-heights="{el : ['.description']}">
          <div class="column is-4" v-for="(item, index) in repos" :key="index">
            <SinglePortfolio :item="item" />
          </div>
      </div>

     <cham-stripes/>

      <div class="columns section" v-cloak>
          <div class="column" v-for="(item, index) in works" :key="index">
            <SinglePortfolio :item="item" />
          </div>
      </div>
    </div>
  </cham-block>
</template>

<script>
import axios from 'axios';
import 'nprogress/nprogress.css';
import NProgress from 'nprogress'
import firebase from '../../firebase';
import SinglePortfolio from '../SinglePortfolio';

export default {
  name : "Portfolio",
  components : {
      SinglePortfolio
  },
  data () {
    return {
      repos : [],
      works : [],
      last : 0,
    }
  },
  mounted () {
    document.title = "Portfolio - Chamara Abeysekara"
  },
  firestore : {
      repos : firebase.db.collection('repos'),
      works : firebase.db.collection('works'),
  },
  computed: {
     busy () {
       return this.repos.length === 0 && this.works.length === 0
     }
  },
   metaInfo: {
    // Children can override the title.
    title: 'Chamara Abeysekara - Portfolio',
    meta: [
      {'http-equiv': 'Content-Type', content: 'text/html; charset=utf-8'},
      {name: 'viewport', content: 'width=device-width, initial-scale=1'},
      {name: 'description', content: 'Work Portfolio'}
    ]
  }
}
</script>

<style lang="scss" >
@import '../../../static/styles.scss';

.content {
    margin-bottom: 2em;
}
.content figure:not(:last-child){
      margin-bottom: 0em;
}
.content figure{
    margin-left: 0em;
    margin-right: 0em;
}
.application{
  margin-top: 3em;
}
</style>



// WEBPACK FOOTER //
// src/componests/pages/Portfolio.vue